(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function nextTarget(month, day) {
    var now = new Date();
    var year = now.getFullYear();
    var target = new Date(year, month - 1, day, 0, 0, 0);
    if (target.getTime() <= now.getTime()) {
      target = new Date(year + 1, month - 1, day, 0, 0, 0);
    }
    return target;
  }

  function tick(el) {
    var month = parseInt(el.dataset.month, 10) || 12;
    var day = parseInt(el.dataset.day, 10) || 25;
    var target = nextTarget(month, day);
    var now = new Date();
    var diff = Math.max(0, target.getTime() - now.getTime());

    var totalMinutes = Math.floor(diff / 60000);
    var days = Math.floor(totalMinutes / (60 * 24));
    var hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    var minutes = totalMinutes % 60;

    var daysEl = el.querySelector('[data-hoov-days]');
    var hoursEl = el.querySelector('[data-hoov-hours]');
    var minutesEl = el.querySelector('[data-hoov-minutes]');

    if (daysEl) daysEl.textContent = days;
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
  }

  function init() {
    var bars = document.querySelectorAll('[data-hoov-countdown]');
    bars.forEach(function (bar) {
      tick(bar);
      setInterval(function () {
        tick(bar);
      }, 60000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
